// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3lhkC","inputWrap":"Table_inputWrap__3E96x","col":"Table_col__38sUI","bmiTooltip":"Table_bmiTooltip__3ueUY"};